import React, { useState, useEffect } from 'react';
import validate from "validate.js";
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import Alert from "@material-ui/lab/Alert";
import FormControl from "@material-ui/core/FormControl";
import clsx from "clsx";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {registerTenantData} from "../../redux/actions/actionStep2";
import {useDispatch, useSelector} from "react-redux";
import { useHistory } from "react-router";
import FormHelperText from "@material-ui/core/FormHelperText";
import Paper from "@material-ui/core/Paper";
import '../../assets/scss/onboarding-step1.css'
import useGaTracker from '../../common/components/ga/useGaTracker'
import useGa4Tracker from '../../common/components/ga/useGa4Tracker'

const userFullNamePattern = /^[\p{L}][\p{L}\p{Z}]*[\p{L}][\p{L}\p{Z}]*[\p{L}]$/u;

const constraints = (t) => ({
  fullName: {
    presence: { allowEmpty: false, message: t('commons.validation.field.required') },
    format: {
      pattern: userFullNamePattern,
    },
    length: {
      minimum: 3, maximum: 30, message: t('onboardingStep3.form.fullName.validateLength')
    },
  },
  password: {
    presence: { allowEmpty: false, message: t('commons.validation.field.required')},
    format: {
      pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\[\\]{};:=.<>_+^#$/!%*?&\\-¡¿\\|ñÑçÇ()])[A-Za-z0-9\\[\\]{};:=.<>_+^#$/!%*?&\\-¡¿\\|ñÑçÇ()]{10,64}$",
    },
    length: {
      minimum: 10, maximum:  64, message: t("commons.validation.field.length")
    }
  },
});

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  paper2: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fffffff2',
    width:'60%',
    padding: '0 5% 0 5%',
    borderRadius: '20px',
    minWidth: '315px',
    maxWidth: '570px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    maxWidth: '500px',
    minWidth: '300px'
  },
  submit: {
    display: 'flex',
    margin: '20px 0px 20px 0px',
    width: '140px',
    background: '#a5166c'
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    textAlign: "center",
    marginTop: "18px"
  },
  logo: {
    height: "60px"
  },
  info: {
    marginTop: "20px",
    fontSize: "15px"
  },
  error: {
    color: "red"
  },
  rowContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: '10px'
  },
  blockElem: {
    display: "flex",
    width: "50%",
  },
  selectPlaceholder: {
    color: "#b5acac",
  }
}));

export const OnboardingStep3 = ({dataStep1, dataStep2, roles, update}) => {

  const dispatch = useDispatch()

  const history = useHistory();

  const classes = useStyles();

  const language = useSelector((state) => state.app.language);

  const [t, i18n] = useTranslation('common');

  const schema = constraints(t);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema, { fullMessages: false });
    setFormState(formState => ({
      ...formState,
        isValid: !errors,
        errors: errors || {}
    }));
  }, [formState.values]);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);


  useEffect(function () {
    const { values } = formState;
    if (values.role && values.role !== '') {
        setValueByUpdateLang('role', undefined);
    }
  }, [i18n.language]);

  const handleChange = event => {
    event.persist();
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values, [event.target.name]: event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const hasError = field =>
      !!(formState.touched[field] && formState.errors[field]);

  const [values, setValues] = useState({
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleOnsubmit = () => {
    const { values } = formState;
    const params = {
      countryCode: dataStep2.country,
      industry: dataStep2.industry,
      langId: dataStep2.lang,
      phoneNumber: dataStep1.tenantOwnerPhoneNumber,
      tenantLabel: dataStep1.tenantLabel,
      tenantName: dataStep2.tenantName,
      timezoneId: dataStep2.timezone,
      userProfile: dataStep2.useProfile,
      userCharge: dataStep2.userCharge,
      userName: values.fullName,
      userPassword: values.password,
      userRole: "charge",
      appSumoAccount: dataStep2.appSumoAccount
    };
    dispatch(registerTenantData({ register: params, history }));
  };

  const setValueByUpdateLang = (field, value) =>{
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [field]: value
      },
      touched: {
        ...formState.touched,
        [field]: false
      }
    }))
  }


  const validador = (pass, t) => {
    if (pass == '') 
      return t('commons.validation.field.required');
      
    const mainPattern =   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\[\]{};:=.<>_+^#$/!%*?&\-¡¿\|ñÑçÇ()])[A-Za-z0-9\[\]{};:=.<>_+^#$/!%*?&\-¡¿\|ñÑçÇ()]{10,64}$/; 
    const lowerCasePattern =   /(?=.*[a-z])/ ;
    const upperCasePattern =   /(?=.*[A-Z])/ ;
    const digitsPattern =   /(?=.*[0-9])/ ;
    const specialPattern = /(?=.*[\[\]{};:=.<>_+^#$/!%*?&\-¡¿\|ñÑçÇ()])/;
    const lengthPattern =   /^.{10,64}$/ ;
  
    const resultado = mainPattern.test(pass);
  
    if (!resultado) {
      if (!lowerCasePattern.test(pass)) {
          return t("onboardingStep3.form.password.missingLowerCase");
      } else if (!upperCasePattern.test(pass)) {
          return t("onboardingStep3.form.password.missingUpperCase");
      }else if (!digitsPattern.test(pass)) {
          return t("onboardingStep3.form.password.missingNumber");
      }else if (!specialPattern.test(pass)) {
          return t("onboardingStep3.form.password.missingSpecialChar");
      }else if (!lengthPattern.test(pass)) {
          return t("onboardingStep3.form.password.outOfRange");
      }else {
          return t("onboardingStep3.form.password.unsupportedSymbol");
      }
    }
    return ""; 
  }

  const userFullNameValidador = (fullName, t) => {
	  
    if (fullName == '') {
		return t('commons.validation.field.required');
	} 
      
    const resultado = userFullNamePattern.test(fullName);
  
    if (!resultado) {
	    return t("onboardingStep3.form.fullName.notMatch");
    }
    return ""; 
  }



  useGaTracker('onboarding-step2-user-data');
  useGa4Tracker('onboarding-step2-user-data');


  return (
         <div className={classes.paper} className="containerStep1">
           <Paper elevation={3} className={classes.paper2} >
             <div className={classes.paper}>
              <Typography  variant="h1" margin="normal" style={{ fontWeight: '700', lineHeight: '50px'}}>
                {t('onboardingStep2.title')}
              </Typography>
              <div >
                <Alert severity="info" className={classes.info} >
                  <strong>{t('onboardingStep3.information')}</strong>
                  {dataStep1 && dataStep1.tenantOwnerEmail ? dataStep1.tenantOwnerEmail: ''}
                </Alert>
              </div>
                <form className={classes.form} >
                  <div>
                    <TextField error={hasError('fullName')}  fullWidth
                        helperText={ hasError('fullName') ? userFullNameValidador(formState.values.fullName, t) : null }
                        margin="normal"
                        label={t('onboardingStep3.form.fullName.label')}
                        name="fullName"
                        onChange={handleChange}
                        type="fullName"
                        value={formState.values.fullName || ''}
                        inputProps={{
                          maxlength: 30
                        }}
                       variant="outlined"/>

                  </div>

                 <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" style={{marginTop: '20px'}}>
                    <InputLabel htmlFor="outlined-adornment-password" >{t('onboardingStep3.form.password.label')}</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        name="password"
                        type={values.showPassword ? 'text' : 'password'}
                        value={formState.values.password}
                        onChange={handleChange}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end">
                              {values.showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        }
                        inputProps={{
                          maxlength: 70
                        }}
                        labelWidth={70}
                        error={hasError('password')}
                    />
                   { hasError('password') &&
                      (<FormHelperText error id="outlined-weight-helper-text">
                        {validador(formState.values.password, t)}
                      </FormHelperText>)
                   }

                 </FormControl>

                <Button  className={classes.submit} color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  size="large"
                  variant="contained"
                  onClick={ () => handleOnsubmit()}>
                    {t('onboardingStep3.form.button')}
                  </Button>
                </form>
             </div>
           </Paper>
         </div>
  );
};

OnboardingStep3.propTypes = {
  history: PropTypes.object
};
